/** Lobby mount point for the same-domain game window (`/game-window-play`). */
export const GAME_WINDOW_PLAY_PATH_PREFIX = '/game-window-play';

export const createPathFilter =
    (prefix: string) =>
    (pathname: string): boolean =>
        pathname === prefix || pathname.startsWith(`${prefix}/`);

/** True when a pathname is the lobby game-window mount (`/game-window-play` or `/game-window-play/...`). */
export const isGameWindowPlayPath = createPathFilter(GAME_WINDOW_PLAY_PATH_PREFIX);
